import { isDefined } from "@clipboard-health/util-ts";
// eslint-disable-next-line no-restricted-imports -- the picker boundary needs to re-anchor wall-clock fields between the browser's tz and the workplace's tz, which @clipboard-health/date-time's instant-based helpers don't do.
import { utcToZonedTime, zonedTimeToUtc } from "date-fns-tz";

// Stored Dates for the shift-migration form are UTC midnight of the picked day
// in the workplace's tz. MUI DatePicker reads/writes browser-local wallclock
// fields, so these helpers re-anchor the calendar day across the boundary.

export function toWorkplaceDayPickerValue(date: Date | null | undefined, tmz: string): Date | null {
  return isDefined(date) ? utcToZonedTime(date, tmz) : null;
}

export function fromWorkplaceDayPickerValue(date: Date | null, tmz: string): Date | null {
  return isDefined(date) ? zonedTimeToUtc(date, tmz) : null;
}
